import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { RejectOrderPaymentRequest, SellerOrderDetail } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateAdminOrders } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type RejectStoreOrderPaymentInput = {
  storeId: string;
  orderId: string;
} & RejectOrderPaymentRequest;

export function useRejectStoreOrderPaymentMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ storeId, orderId, ...body }: RejectStoreOrderPaymentInput) =>
      apiJsonClient<SellerOrderDetail>(
        endpoints.admin.storeOrderReviewReject(storeId, orderId),
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(body),
        },
      ),
    onSuccess: async (_data, variables) => {
      await invalidateAdminOrders(queryClient, variables.storeId);
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.admin.storeOrderById(variables.storeId, variables.orderId),
          exact: true,
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.admin.storeOrderProof(variables.storeId, variables.orderId),
          exact: true,
        }),
      ]);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
  };
}
